$(document).ready(function() {

    /*******************************************/
    //Form Validation
    $('.validate-form').each(function() {
        $(this).validate({
            submitHandler: function(form) {
                form.submit();
            },
            rules: {
                required: true
            },
            errorPlacement: function(error, element) {
                error.appendTo(element.parents('.form-field'));
            },
            highlight: function(element, errorClass, validClass) {
                if (element.type === 'radio') {
                    this.findByName(element.name).parents('.form-field').addClass(errorClass).removeClass(validClass);
                } else {
                    $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
                }
            },
            unhighlight: function(element, errorClass, validClass) {
                if (element.type === 'radio') {
                    this.findByName(element.name).parents('.form-field').removeClass(errorClass).addClass(validClass);
                } else {
                    $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
                }
            }
        });
    });

    /*******************************************/
    //Lightbox Initiations
    // $('.js-inline-popup').magnificPopup({
    //     type:'inline',
    //     showCloseBtn: true,
    //     closeOnBgClick: true,
    //     callbacks: {
    //         open: function() {
    //         $.magnificPopup.instance.close = function() {
    //             // Do whatever else you need to do here
    //             $('audio').each(function(){
    //                 this.pause(); // Stop playing
    //                 this.currentTime = 0; // Reset time
    //             }); 

    //             // Call the original close method to close the popup
    //             $.magnificPopup.proto.close.call(this);
    //         };
    //         }
    //     }
    // });

    $('.js-image-popup').magnificPopup({
        type: 'image',
        showCloseBtn: true,
        closeOnBgClick: true
    });

    $('.lightbox-manual-close-trigger').click(function(event) {
        e.preventDefault();
        $.magnificPopup.close();
    });

    /*******************************************/
    // Tabs
    $('.js-tab-triggers a').on('click', function(e) {
        e.preventDefault();
        $('.js-tab-triggers a').not(this).removeClass('active');
        $(this).addClass('active');
        var getTarget = $(this).attr('href');
        $('.tab-content').not(getTarget).hide();
        $(getTarget).show();
    });

    /*******************************************/
    // News toggle
    $('.js-toggle-info').on('click', function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('open');

        $(this).toggleHTML('<span class="material-icons">expand_less</span> Read Less', '<span class="material-icons">expand_more</span> Read More');
    });

    /*******************************************/

    $('.page-about .wrap').addClass('reveal');


});
/*******************************************/


$.fn.toggleHTML = function(t1, t2) {
    if (this.html() == t1) this.html(t2);
    else this.html(t1);
    return this;
};

/*******************************************/






// WEBPACK FOOTER //
// ./resources/assets/frontend/js/scripts/common.js